var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4217_2355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 7.04256C10.8332 9.75089 8.93734 11.1051 6.684 11.8905C6.56601 11.9305 6.43784 11.9286 6.32109 11.8851C4.06234 11.1051 2.1665 9.75089 2.1665 7.04256V3.25089C2.1665 3.10724 2.22357 2.96946 2.32515 2.86788C2.42674 2.7663 2.56451 2.70923 2.70817 2.70923C3.7915 2.70923 5.14567 2.05923 6.08817 1.23589C6.20293 1.13785 6.3489 1.08398 6.49984 1.08398C6.65077 1.08398 6.79675 1.13785 6.9115 1.23589C7.85942 2.06464 9.20817 2.70923 10.2915 2.70923C10.4352 2.70923 10.5729 2.7663 10.6745 2.86788C10.7761 2.96946 10.8332 3.10724 10.8332 3.25089V7.04256Z",
    fill: "#358CFF",
    stroke: "#358CFF",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.875 6.49935L5.95833 7.58268L8.125 5.41602",
    stroke: "white",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4217_2355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedIcon);
export default __webpack_public_path__ + "static/media/TrustedIcon.ad7d66b2b708a8557839dfc512edb982.svg";
export { ForwardRef as ReactComponent };